import classNames from "classnames";
import { inject } from "mobx-react";
import React, { useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import { withStyles } from "@material-ui/core";
import styles from "./DentesStyles";
import Dente from "../../Components/Dente";
import { menuOpcoesPopperLocal } from "../../Constants";
import DivisorTipoDente from "../../Components/DivisorTipoDente";
import DivisorVisualizacaoDente from "../../Components/DivisorVisualizacaoDente";
import PopperCustomMenu from "../../../../../../components/Popper/PopperCustomMenu";
import DivisorAreaDenteSupranumerario from "../../Components/DivisorAreaDenteSupranumerario";

const Dentes = observer(
  ({ classes, odontogramaStore, openDrawer, prontuarioStore }) => {
    const {
      tabVisualizacaoSelected,
      dentes,
      isTelaAmpliada,
      locaisSelecionados,
      odontograma,
      isClickRightLocalSelecionado,
    } = odontogramaStore;

    const popperRefs = useRef({});

    const tipoDentePermanente = tabVisualizacaoSelected === 0;
    const quantidadeDentes = tipoDentePermanente ? 16 : 10;
    const dentesSuperior = dentes.slice(0, quantidadeDentes);
    const dentesInferior = dentes.slice(quantidadeDentes, dentes.length);

    useEffect(() => {
      odontograma.id && getTodosLocais();
    }, [odontograma.id]);

    const getTodosLocais = () => {
      odontogramaStore.loadTodosLocais();
    };

    const isTipoLocalMucosa = () => {
      return (
        locaisSelecionados.length > 0 &&
        locaisSelecionados.some((item) => item.local !== 4)
      );
    };

    const selectDente = (dente) => {
      let listaLocaisSelecionados = [...locaisSelecionados];

      const dentesSelecionados = dentes.map((element) => ({
        ...element,
        selecionado:
          dente.id === element.id ? !dente?.selecionado : element.selecionado,
      }));

      if (dente.selecionado) {
        listaLocaisSelecionados = dentesSelecionados.filter(
          (item) => item.selecionado,
        );
      } else {
        listaLocaisSelecionados.push({ ...dente, selecionado: true });
      }

      odontogramaStore.dentes = dentesSelecionados;
      odontogramaStore.locaisSelecionados = listaLocaisSelecionados;
    };

    const openModalObservacao = (e) => {
      odontogramaStore.modalObservacao.showModalObservacao = true;
      const pop = popperRefs.current?.[locaisSelecionados?.[0]?.id];
      const api = pop?.handleOpenPopper ? pop : pop?.current;
      return api?.closePopper?.(e);
    };

    const openModalProcedimento = (e) => {
      odontogramaStore.modalProcedimento.showModalProcedimento = true;
      const pop = popperRefs.current?.[locaisSelecionados?.[0]?.id];
      const api = pop?.handleOpenPopper ? pop : pop?.current;
      return api?.closePopper?.(e);
    };

    const openModalHistorico = (e) => {
      odontogramaStore.showModalHistorico = true;
      const pop = popperRefs.current?.[locaisSelecionados?.[0]?.id];
      const api = pop?.handleOpenPopper ? pop : pop?.current;
      return api?.closePopper?.(e);
    };

    const handleAlteraStatusDente = async (e) => {
      const dentes = [
        {
          id: locaisSelecionados[0].id,
          status:
            locaisSelecionados[0].status === "ATIVO" ? "INATIVO" : "ATIVO",
        },
      ];

      await odontogramaStore.alterarStatusDente(dentes);

      odontogramaStore.getOdontograma(
        prontuarioStore.sujeitoAtencaoSelected.id,
      );

      const pop = popperRefs.current?.[locaisSelecionados?.[0]?.id];
      const api = pop?.handleOpenPopper ? pop : pop?.current;
      return api?.closePopper?.(e);
    };

    const dadosMenuOpcoes = (dente) => ({
      isDente: true,
      ativo: dente.status === "ATIVO",
      functions: {
        openModalProcedimento,
        openModalObservacao,
        openModalHistorico,
        handleAlteraStatusDente,
      },
    });

    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    const lpTimer = useRef(null);
    const lpTriggered = useRef(false);
    const lpData = useRef({ anchorEl: null, clientX: 0, clientY: 0 });

   const cancelLongPress = () => {
  if (lpTimer.current) {
    clearTimeout(lpTimer.current);
    lpTimer.current = null;
  }
  lpTriggered.current = false; 
};

    const openPopperDoDente = (dente, e) => {
      const pop = popperRefs.current?.[dente.id];
      const api = pop?.handleOpenPopper ? pop : pop?.current;
      return api?.handleOpenPopper?.(e);
    };

    const handleLongPress = (dente) => {
      if (isTipoLocalMucosa()) return;

      odontogramaStore.locaisSelecionados = [dente];
      odontogramaStore.isClickRightLocalSelecionado = true;

      const evt = {
        currentTarget: lpData.current.anchorEl,
        target: lpData.current.anchorEl,
        clientX: lpData.current.clientX,
        clientY:lpData.current.clientY,
        preventDefault: () => {},
        stopPropagation: () => {},
        button: 2,
        which: 3,
      };

      openPopperDoDente(dente, evt);
    };

    const onPointerDown = (e, dente) => {
      if (e.pointerType !== "touch") return;

      if (e?.persist) e.persist();
      lpTriggered.current = false;

      lpData.current = {
        anchorEl: e.currentTarget,
        clientX: 111,
        clientY: 111,
      };

      lpTimer.current = setTimeout(() => {
        lpTriggered.current = true;
        handleLongPress(dente);
      }, 550);
    };

    const onPointerUp = () => {
      cancelLongPress();
    };

    const handleClickDente = (e, dente) => {
      if (isTipoLocalMucosa()) return;

      if (isClickRightLocalSelecionado && locaisSelecionados.length === 1) {
        odontogramaStore.locaisSelecionados = [];
      }

      const isLeftClick =
        e?.which === 1 || e?.button === 0 || e?.button == null;
      const isRightClick = e?.which === 3 || e?.button === 2;

      if (isLeftClick) {
        selectDente(dente);
        odontogramaStore.isClickRightLocalSelecionado = false;
        return;
      }

      const denteRepetido = locaisSelecionados.some(
        (item) => item.id === dente.id,
      );

      if (
        (locaisSelecionados.length === 0 ||
          (denteRepetido && locaisSelecionados.length === 1)) &&
        isRightClick
      ) {
        odontogramaStore.locaisSelecionados = [dente];
        odontogramaStore.isClickRightLocalSelecionado = true;

        return openPopperDoDente(dente, e);
      }

      odontogramaStore.isClickRightLocalSelecionado = false;
    };

    const onMouseUpDente = (e, dente) => {
     
      handleClickDente(e, dente);
    };

    return (
      <div className={classes.content} onContextMenu={handleContextMenu}>
        <DivisorVisualizacaoDente />

        <div
          className={classNames(
            classes.contentDentes,
            !openDrawer && classes.contentCloseDrawer,
            isTelaAmpliada && classes.contentTelaCheia,
          )}
        >
          <div className={classes.dentes}>
            {dentesSuperior.map((dente, index) => (
              <PopperCustomMenu
                ref={(ref) => (popperRefs.current[dente.id] = ref)}
                placement={"bottom"}
                colorButton={{ background: "#fff" }}
                menuOpcoes={menuOpcoesPopperLocal(dadosMenuOpcoes(dente))}
                key={dente.id}
              >
                <div
                  className={classes.dente}
                  onMouseUp={(e) => onMouseUpDente(e, dente)}
                  onPointerDown={(e) => onPointerDown(e, dente)}
                  onPointerUp={onPointerUp}
                  onPointerCancel={cancelLongPress}
                  onPointerLeave={cancelLongPress}
                  onContextMenu={(e) => e.preventDefault()}
                   id={`prt-dnt-div-sup-${index}`}
                >
                  <DivisorTipoDente index={index} />
                  <Dente dente={dente} isPosicaoSuperior />
                </div>
              </PopperCustomMenu>
            ))}
          </div>

          <div className={classes.divisor} />

          <div className={classes.dentes}>
            {dentesInferior.map((dente,index) => (
              <PopperCustomMenu
                ref={(ref) => (popperRefs.current[dente.id] = ref)}
                placement={"bottom"}
                colorButton={{ background: "#fff" }}
                menuOpcoes={menuOpcoesPopperLocal(dadosMenuOpcoes(dente))}
                key={dente.id}
              >
                <div
                  onMouseUp={(e) => onMouseUpDente(e, dente)}
                  onPointerDown={(e) => onPointerDown(e, dente)}
                  onPointerUp={onPointerUp}
                  onPointerCancel={cancelLongPress}
                  onPointerLeave={cancelLongPress}
                  onContextMenu={(e) => e.preventDefault()}
                   id={`prt-dnt-div-inf-${index}`}
                >
                  <Dente dente={dente} invert />
                </div>
              </PopperCustomMenu>
            ))}
          </div>
        </div>

        <DivisorAreaDenteSupranumerario />
      </div>
    );
  },
);

const DentesWithStyles = withStyles(styles)(Dentes);
export default inject("odontogramaStore", "prontuarioStore")(DentesWithStyles);
